import { Utils } from "./utils";

const YEARS = 'years';
const MONTHS = 'months';
const DAYS = 'days';

export class ValidationHelper {
    static validateText(input: any, validierung: string): ValidationResult {
        return { isValid: true };
    }

    static validateCheckbox(input: any, validierung: string): ValidationResult {
        return { isValid: true };
    }

    static validateZahl(input: any, validierung: string): ValidationResult {
        return { isValid: true };
    }

    static validateDezimalzahl(input: any, validierung: string): ValidationResult {
        return { isValid: true };
    }

    static validateBarcode(input: any, validierung: string): ValidationResult {
        return { isValid: true };
    }

    /**
     * Validiert, ob sich das Datum im konfigurierten Bereich befindet.
     * Als Validierung können z.B. folgende Formate verwendet werden:
     * - min_age:18:years
     * - max_age:6:months
     *
     * Mehrere Regeln können mit '|' getrennt angegeben werden.
     */
    static validateDatum(input: any, validierung: string): ValidationResult {
        if (!validierung) {
            // Keine Validierung angegeben. Damit ist keine Prüfung erforderlich.
            return { isValid: true };
        }

        // input = Utils.trimToEmpty(input);

        const now = new Date();

        const regeln = validierung.split('|');

        // Handelt es sich um ein Pflichtfeld?
        let pflicht = false;

        for (const regel of regeln) {
            if (!regel) {
                continue;
            }

            let [operator, v2, v3, v4] = regel.split(':');

            operator = Utils.trimToEmpty(operator).toLowerCase();
            v2 = Utils.trimToEmpty(v2);
            v3 = Utils.trimToEmpty(v3);
            v4 = Utils.trimToEmpty(v4);

            if (operator === 'pflicht') {
                if (Utils.isTrue(v2)) {
                    pflicht = true;
                }
            }
        }

        if (!input) {
            if (pflicht) {
                return { isValid: false };
            } else {
                return { isValid: true };
            }
        }

        let inputDate: Date = null;

        if (input instanceof Date) {
            inputDate = input;
        } else if (typeof input === 'string') {
            const inputDatum = Utils.parseDatum(input);

            if (!inputDatum) {
                return { isValid: false, message: 'Ungültiges Datum' };
            }

            inputDate = inputDatum.toDate();
        } else {
            return { isValid: false, message: 'Ungültige Eingabe: ' + input };
        }

        for (const regel of regeln) {
            if (!regel) {
                continue;
            }

            let [operator, anzahl, einheit, meldung] = regel.split(':');

            operator = Utils.trimToEmpty(operator).toLowerCase();
            anzahl = Utils.trimToEmpty(anzahl);
            einheit = Utils.trimToEmpty(einheit).toLowerCase();
            meldung = Utils.trimToEmpty(meldung);

            // Einheit normalisieren
            if (einheit) {
                if (einheit === 'd' || einheit === 'day' || einheit === 'days' || einheit === 'tag' || einheit === 'tage') {
                    einheit = DAYS;
                } else if (einheit === 'm' || einheit === 'month' || einheit === 'months' || einheit === 'monat' || einheit === 'monate') {
                    einheit = MONTHS;
                } else if (einheit === 'y' || einheit === 'year' || einheit === 'years' || einheit === 'jahr' || einheit === 'jahre') {
                    einheit = YEARS;
                }
            }

            if (operator === 'min_alter') {
                const targetDate = new Date(now);
                const value = parseInt(anzahl);

                if (einheit === MONTHS) {
                    targetDate.setMonth(now.getMonth() - value);
                } else if (einheit === YEARS) {
                    targetDate.setFullYear(now.getFullYear() - value);
                } else if (einheit === DAYS) {
                    targetDate.setDate(now.getDate() - value);
                }

                if (inputDate > targetDate) {
                    if (!meldung) {
                        meldung = 'Das Datum ist zu jung';
                    }

                    return { isValid: false, message: meldung };
                }
            }

            if (operator === 'max_alter') {
                const targetDate = new Date(now);
                const value = parseInt(anzahl);

                if (einheit === MONTHS) {
                    targetDate.setMonth(now.getMonth() - value);
                } else if (einheit === YEARS) {
                    targetDate.setFullYear(now.getFullYear() - value);
                } else if (einheit === DAYS) {
                    targetDate.setDate(now.getDate() - value);
                }

                if (inputDate < targetDate) {
                    if (!meldung) {
                        meldung = 'Das Datum ist zu alt';
                    }

                    return { isValid: false, message: meldung };
                }
            }

            // TODO:Datum in der Zukunft prüfen
            if (operator === 'min_xxx') {

            }
        }

        return { isValid: true };

        // Format: <6M
        // d.h. das Datum darf höchsten 6 Monate alt sein.
        // const regex = /^([<>])(\d+)([MDY])$/;

        // const match = input.match(regex);

        // let minDatum: Date = null;
        // let maxDatum: Date = null;

        // if (match) {
        //     const operator = match[1]; // das < oder >
        //     const value = match[2]; // die Zahl
        //     const unit = match[3]; // M, D oder Y

        //     if (operator == '<') {

        //     }
        // }
    }
}

export interface ValidationResult {
    isValid: boolean;
    message?: string;
}